"use client";

import { useSyncExternalStore } from "react";
import { Clock } from "lucide-react";
import Link from "next/link";
import { getRecentViews, type RecentView } from "@/lib/recent-views";
import { wikiLink } from "@/lib/url";

const STORAGE_KEY = "skinagent_recent_views";
const EMPTY: RecentView[] = [];

// getSnapshot은 안정된 참조를 반환해야 함 — raw 문자열이 동일하면 동일 배열 참조 유지
let cachedRaw = "__INIT__";
let cachedItems: RecentView[] = EMPTY;

function getSnapshot(): RecentView[] {
  if (typeof window === "undefined") return EMPTY;
  const raw = localStorage.getItem(STORAGE_KEY) || "";
  if (raw !== cachedRaw) {
    cachedRaw = raw;
    cachedItems = getRecentViews();
  }
  return cachedItems;
}

function subscribe(onChange: () => void) {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
}

export function RecentViewsSection() {
  const items = useSyncExternalStore<RecentView[]>(subscribe, getSnapshot, () => EMPTY);

  if (items.length === 0) return null;

  return (
    <section className="px-5 py-6">
      <h2 className="mb-3 flex items-center gap-2 text-base font-bold">
        <Clock className="h-4 w-4 text-gray-400" />
        최근 본 시술
      </h2>
      <div className="scrollbar-none -mx-5 flex gap-2 overflow-x-auto px-5 pb-1">
        {items.map((v) => (
          <Link
            key={v.slug}
            href={wikiLink(v.slug)}
            className="shrink-0 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-violet-300 hover:text-violet-700"
          >
            {v.title}
          </Link>
        ))}
      </div>
    </section>
  );
}
